export default __webpack_public_path__ + "static/blockchain_solution-a5c9f1bf7f93258ffc7d37ca772da909.webp";